import { render } from "./model-completions.vue?vue&type=template&id=56e965c2"
import script from "./model-completions.vue?vue&type=script&lang=js"
export * from "./model-completions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__